module.exports = __webpack_public_path__ + "img/06.b0000e70.png";